import { fetchAssessmentScoresByApplication } from '@actions/assessments';
import {
    getApplicationScores,
    getAssessmentsIsFeching,
    getAssessmentsFetchError,
} from '@selectors/assessments';

import useHasRole from 'lib/src/hooks/useHasRole';
import { userRoles } from 'lib/src/shared/enums/dropdownEnums';
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';

const useFetchSubmissionScores = (applicationID: number) => {
    const isSuperAdmin = useHasRole(userRoles.superAdmin);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!isSuperAdmin) return;

        dispatch(fetchAssessmentScoresByApplication(applicationID));
    }, [dispatch, isSuperAdmin, applicationID]);

    const scores = useSelector((state: RootState) =>
        getApplicationScores(state, applicationID ?? -1),
    );
    const isFetching = useSelector(getAssessmentsIsFeching);
    const fetchError = useSelector(getAssessmentsFetchError);

    return { scores, isFetching, fetchError };
};

export default useFetchSubmissionScores;
